module.exports = __webpack_public_path__ + "/login_ui/img/my-ac920fd65e77a297115a5d27b4352ae5.svg";